import React, { useState, useEffect } from 'react';
import HeaderMobile from './HeaderMobile.js';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Footer from './Footer.js';  // Import Footer component
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from "./Constants.js";
const Mapping = () => {
  const [newUser, setNewUser] = useState({
    type_id: '',
    size_id: '',
    color_id: '',
    cost: '',
  });
  const [areas, setAreas] = useState([]);
  const [dressTypes, setDressTypes] = useState([]); // State for dress types
  const [dressSizes, setDressSizes] = useState([]); // State for dress types
  const [dressColors, setDressColors] = useState([]); // State for dress types
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [formError, setFormError] = useState(null);
  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state
  const navigate = useNavigate(); // Use navigate hook

  // Fetch dress types data from the API when the component mounts

  useEffect(() => {
    const fetchAreas = async () => {
      try {
        const token = localStorage.getItem('authToken');
        console.log(token);

        // If no token is found, handle the error
        if (!token) {
          setError('No token found!');
          setLoading(false);
          return;
        }

        const response =await fetch(`${BASE_URL}get_map_id`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

       

        const data = await response.json();
        console.log('Fetched data:', data);

        if (data && data.areas && Array.isArray(data.areas)) {
          // Filter out dress types with status 'A'
          const activeAreas = data.areas.filter(area => area.status === 'A');
          setAreas(activeAreas); // Set active dress types
        } 
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAreas();
  }, []); // Only runs once when the component mounts
  useEffect(() => {
    const fetchAreas = async () => {
      try {
        const token = localStorage.getItem('authToken');
        console.log(token);

        // If no token is found, handle the error
        if (!token) {
          setError('No token found!');
          setLoading(false);
          return;
        }

        const response =await fetch(`${BASE_URL}areas`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

       

        const data = await response.json();
        console.log('Fetched data:', data);

        if (data && data.areas && Array.isArray(data.areas)) {
          // Filter out dress types with status 'A'
          const activeAreas = data.areas.filter(area => area.status === 'A');
          setAreas(activeAreas); // Set active dress types
        } 
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAreas();
  }, []); // Only runs once when the component mounts

  // Fetch dress types data from the API when the component mounts
  useEffect(() => {
    const fetchDressTypes = async () => {
      try {
        const token = localStorage.getItem('authToken');
        console.log(token);

        // If no token is found, handle the error
        if (!token) {
          setError('No token found!');
          setLoading(false);
          return;
        }

        const response =await fetch(`${BASE_URL}dress_types`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

       

        const data = await response.json();
        console.log('Fetched data:', data);

        if (data && data.dressTypes && Array.isArray(data.dressTypes)) {
          // Filter out dress types with status 'A'
          const activeDressTypes = data.dressTypes.filter(type => type.status === 'A');
          setDressTypes(activeDressTypes); // Set active dress types
        } 
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchDressTypes();
  }, []); // Only runs once when the component mounts

   // Fetch users data from the API when the component mounts
   useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem('authToken');
        console.log(token);

        // If no token is found, handle the error
        if (!token) {
          setError('No token found!');
          setLoading(false);
          return;
        }

        const response = await fetch(`${BASE_URL}dress_sizes`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        

        const data = await response.json();
        console.log('Fetched data:', data);

        if (data && data.dressSizes && Array.isArray(data.dressSizes)) {
          // Filter out users with status 'A'
          const activeDressSizes = data.dressSizes.filter(user => user.status === 'A');
          setDressSizes(activeDressSizes);
        
        } 
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []); // Only runs once when the component mounts

  // Fetch users data from the API when the component mounts
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem('authToken');
        console.log(token);

        // If no token is found, handle the error
        if (!token) {
          setError('No token found!');
          setLoading(false);
          return;
        }

        const response = await fetch(`${BASE_URL}dress_colors`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        

        const data = await response.json();
        console.log('Fetched data:', data);

        if (data && data.dressColors && Array.isArray(data.dressColors)) {
          // Filter out users with status 'A'
          const activeDressColors = data.dressColors.filter(user => user.status === 'A');
          setDressColors(activeDressColors);
        
        } 
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []); // Only runs once when the component mounts
  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewUser({
      ...newUser,
      [name]: value,
    });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Simple form validation
    if (!newUser.type_id || !newUser.size_id || !newUser.color_id || !newUser.cost) {
      setFormError('All fields are required.');
      return;
    }

    try {
      const token = localStorage.getItem('authToken');
      const formData = new FormData();
      formData.append('area_id', newUser.area_id);
      formData.append('type_id', newUser.type_id);
      formData.append('size_id', newUser.size_id);
      formData.append('color_id', newUser.color_id);
      formData.append('cost', newUser.cost);

      const response = await fetch(`${BASE_URL}add_cost`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error('Failed to add dress color');
      }

      // Redirect to the Manage Dress Color page after successful submission
      navigate('/manage_mapping'); // Modify this route if needed

    } catch (err) {
      setFormError(err.message);
    }
  };
  const handleToggleSidebar = () => {
    if (window.innerWidth >= 992) {
      setIsSidebarOpen(prev => !prev);
    }
  };
  const handleCancel = () => {
    navigate('/manage_mapping');
  }
  return (
    <div className="page-wrapper">
      <HeaderMobile />
      <Sidebar isOpen={isSidebarOpen} />
      <div className="page-container" style={{
        marginLeft: isSidebarOpen && window.innerWidth >= 992 ? '300px' : '0',
        transition: 'margin-left 0.3s ease',
        
      }}>
      <Header onToggleSidebar={handleToggleSidebar} isSidebarOpen={isSidebarOpen}/>
        <div className="main-content">
          <div className="section__content section__content--p30">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12 offset-lg-0">
                  {/* Add Dress Color Card */}
                  <div className="card add-user-card">
                    <div className="card-header">
                      <h2>Mapping</h2>
                    </div>
                    <div className="card-body">
                      {/* Add Dress Color Form */}
                      <form onSubmit={handleSubmit}>
                        {formError && <div className="alert alert-danger">{formError}</div>}
                        {error && <div className="alert alert-danger">{error}</div>}
                        {loading && <div className="alert alert-info">Loading dress types...</div>}

                        <div className="form-row">
                        <div className="form-group col-md-3">
                            <label htmlFor="area_id">Location</label>
                            <select
                              id="area_id"
                              name="area_id"
                              className="form-control"
                              value={newUser.area_id}
                              onChange={handleInputChange}
                              required
                            >
                              <option value="">Select Area</option>
                              {/* Dynamically populate options from fetched dress types */}
                              {areas.map((area) => (
                                <option key={area.id} value={area.id}>
                                  {area.area}
                                </option>
                              ))}
                            </select>
                          </div>
                          {/* Type Dropdown */}
                          <div className="form-group col-md-3">
                            <label htmlFor="type_id">Type</label>
                            <select
                              id="type_id"
                              name="type_id"
                              className="form-control"
                              value={newUser.type_id}
                              onChange={handleInputChange}
                              required
                            >
                              <option value="">Select Type</option>
                              {/* Dynamically populate options from fetched dress types */}
                              {dressTypes.map((dressType) => (
                                <option key={dressType.id} value={dressType.id}>
                                  {dressType.dress_type}
                                </option>
                              ))}
                            </select>
                          </div>

                          {/* Size Dropdown */}
                          <div className="form-group col-md-2">
                            <label htmlFor="size_id">Size</label>
                            <select
                              id="size_id"
                              name="size_id"
                              className="form-control"
                              value={newUser.size_id}
                              onChange={handleInputChange}
                              required
                            >
                              <option value="">Select Size</option>
                              {/* Dynamically populate options from fetched dress types */}
                              {dressSizes.map((dressSize) => (
                                <option key={dressSize.id} value={dressSize.id}>
                                  {dressSize.dress_size}
                                </option>
                              ))}
                            </select>
                          </div>

                          {/* Color Dropdown */}
                          <div className="form-group col-md-2">
                            <label htmlFor="color_id">Color</label>
                            <select
                              id="color_id"
                              name="color_id"
                              className="form-control"
                              value={newUser.color_id}
                              onChange={handleInputChange}
                              required
                            >
                              <option value="">Select Color</option>
                              {/* Dynamically populate options from fetched dress types */}
                              {dressColors.map((dressColor) => (
                                <option key={dressColor.id} value={dressColor.id}>
                                  {dressColor.dress_color}
                                </option>
                              ))}
                            </select>
                          </div>

                          {/* Cost Input */}
                          <div className="form-group col-md-2">
                            <label htmlFor="cost">Cost</label>
                            <input
                              type="number"
                              id="cost"
                              name="cost"
                              className="form-control"
                              value={newUser.cost}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div style={{ display: 'flex', gap: '10px' }}>
                        <button type="submit" className="btn btn-primary">
                          Submit
                        </button>
                        <button type="button" className="btn btn-secondary" onClick={handleCancel}>
                            Cancel
                          </button>
                          </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer /> {/* Footer will stick to the bottom */}
      </div>
    </div>
  );
};

export default Mapping;
